import React, { useState, useEffect} from "react";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardDatePicker
} from "@material-ui/pickers";
import { timeZoneChange, timeZoneChanger } from "../../components/Cookies/Cookies";

import Autocomplete from "@material-ui/lab/Autocomplete";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
	itemColumn: {
		alignSelf: "center",
    textAlign: "left"
	}
}));

export default function AddSupplierModal(props) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [item, setItem] = useState('');
	const [qty, setQty] = useState('');
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [item_order_data, setItem_order_data] =useState([]);
	const [maxDate, setMaxDate] = useState("");
	const [minDate, setMinDate] = useState("");

	useEffect(() => {
		timeZoneChange(setItem_order_data);
		timeZoneChanger(setMaxDate);
		timeZoneChanger(setMinDate);
		if (item && qty!=0 ) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [item, qty]);

	const handleOpen = () => {
		setOpen(true);
		setQty('');
	};

	const handleClose = () => {
		setOpen(false);
		setQty('');
	};
	const {supplierItem, addItem} = props;

	const selectItemProps = {
		//options: dummy_item_array,
		options: supplierItem, //pass the items array as props from PurchaseOrderInformation
		getOptionLabel: (option) => option.itemname
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		item.qty = parseInt(qty);
		const new_obj = Object.assign(item, item_order_data);
		addItem(new_obj);
		handleClose();
		setItem_order_data({
			manufacturing_date: format(new Date(), "yyyy-MM-dd"),
			expiration_date: format(new Date(), "yyyy-MM-dd"),
			batch_no: ""
		});
        //setTitle(''); close the popup after adding
    }

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);



	const handleDateChange = (date, type) => {
		date = format(date, "yyyy-MM-dd");
		setItem_order_data(prevState => ({
			...prevState,
			[type]: date
		}));
	};

	return (
		<div>
			{/* <button type="button" onClick={handleOpen}>
				react-transition-group
			</button> */}
			<Button style={{minWidth: "190px",marginBottom:"0.5em", marginRight:"0.5em"}} variant="outlined" color="primary" onClick={handleOpen}>
				Add Item Order
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
				size="small"
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<h2 id="transition-modal-title">Add Item</h2>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={3}>
								<Grid item xs={3} className={classes.itemColumn}>
									Item
								</Grid>
								<Grid item xs={9}>
								<Autocomplete
										{...selectItemProps}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Item"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												setItem(newValue);
											}else{
												setItem(null);
											}
										}}
									/>
								</Grid>
								<Grid item xs={3} className={classes.itemColumn}>
									Quantity
								</Grid>
								<Grid item xs={9}>
									<TextField
										required
										id="outlined-required"
										label="Quantity"
										variant="outlined"
										type="number"
										value={qty}
										InputProps={{ inputProps: { min: 0 } }}
										onKeyPress={(e) => { 
											if(e.key == '-'){
												e.preventDefault();
											}
										 }}
										onChange={e => {
											setQty(e.target.value);
										}}
										onBlur={(e) => {
											if(parseInt(e.target.value) > 0){
												setQty(e.target.value);
											}else{
												setQty(0);
											}
										}}
									/>
								</Grid>
								<Grid item xs={3} className={classes.itemColumn}>
									Manufacturing Date
								</Grid>
								<Grid item xs={9}>
								<MuiPickersUtilsProvider
										utils={DateFnsUtils}
									>
										<KeyboardDatePicker
											autoOk
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Manufacturing Date"
											maxDate={maxDate}
										
											value={item_order_data.manufacturing_date}
											onChange={date => handleDateChange(date,"manufacturing_date")}
											inputVariant="outlined"
											margin="normal"
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}
											inputProps={{readOnly:"true"}}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item xs={3} className={classes.itemColumn}>
									Expiration Date
								</Grid>
								<Grid item xs={9}>
									<MuiPickersUtilsProvider
										utils={DateFnsUtils}
									>
										<KeyboardDatePicker
											autoOk
											// disablePast
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Transaction Date"
											minDate={minDate}
											value={item_order_data.expiration_date}
											onChange={date => handleDateChange(date,"expiration_date")}
											inputVariant="outlined"
											margin="normal"
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}
											inputProps={{readOnly:"true"}}
										/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item xs={3} className={classes.itemColumn}>
									Batch No.
								</Grid>
								<Grid item xs={9}>
									<TextField
										size="small"
										// required
										id="outlined-required"
										label="Batch No."
										variant="outlined"
										type="text"
										value={ item_order_data.batch_no }
										name="batch_no"
										onChange={ e =>
											setItem_order_data( prevState => ({
												...prevState,
												[e.target.name]: e.target.value
											}))
										}
									/>
								</Grid>
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<ColorButton disabled={btnDisabled} type="submit" variant="contained" color="primary"  classes={{
    								root: classes.root, 
        							disabled: classes.disabled}}>
									Add Inventory
									</ColorButton>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
